import "core-js/modules/es.array.concat.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment-timezone';
export default /*#__PURE__*/_defineComponent({
  __name: 'BSaleEndTimer',
  props: {
    countdownEnd: {
      type: Date,
      default: null
    },
    color: {
      type: String,
      default: null
    }
  },
  emits: ['timer-end'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var whitelabel = useWhitelabel();
    var color = computed(function () {
      var _props$color;
      return (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : whitelabel.lightTheme.textPrimary.lighten5;
    });
    var timerText = ref(null);
    var endMoment = null;
    var intervalId = null;
    function formatDuration(duration) {
      var hourDuration = moment.utc(duration.asMilliseconds()).format('H[H] m[M] s[S]');
      // Convert months, years to days
      var days = Math.floor(duration.asDays());
      // Don't show days if there is less than 1 day left
      if (days > 0) {
        return "".concat(days, "D ").concat(hourDuration);
      }
      return hourDuration;
    }
    function timerTick() {
      var durationLeft = moment.duration(endMoment.diff(moment()));
      timerText.value = formatDuration(durationLeft);
      if (durationLeft.asMilliseconds() <= 0) {
        clearInterval(intervalId);
        emit('timer-end');
      }
    }
    function startTimer() {
      timerTick();
      intervalId = setInterval(timerTick, 1000);
    }
    function setTimer(endTime) {
      clearInterval(intervalId);
      if (endTime) {
        endMoment = moment(endTime);
        startTimer();
      } else {
        endMoment = null;
      }
    }
    watch(function () {
      return props.countdownEnd;
    }, function (newValue) {
      setTimer(newValue);
    });
    onMounted(function () {
      setTimer(props.countdownEnd);
    });
    onUnmounted(function () {
      clearInterval(intervalId);
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      whitelabel: whitelabel,
      color: color,
      timerText: timerText,
      endMoment: endMoment,
      intervalId: intervalId,
      formatDuration: formatDuration,
      timerTick: timerTick,
      startTimer: startTimer,
      setTimer: setTimer
    };
  }
});